import { httpCreate } from './http';

const http = httpCreate('/srv/preheat');

export const preheat = {
	preheatList(id, params) {
		return http.get(`/list/${id}`, { params });
	},
	preheatTotalList(id) {
		return http.get(`/listNoPage/${id}`);
	},
	addPreheat(data) {
		return http.post('', data);
	},
	modifyPreheat(data) {
		return http.put('', data);
	},
	deletePreheat(id) {
		return http.delete(`/${id}`);
	},
	getStat(id, params) {
		return http.get(`/stat/${id}`, { params });
	},
	setVirtual(id, data) {
		return http.put(`/virtual/${id}`, data);
	},
	userList(id, params) {
		return http.get(`/userlist/${id}`, { params });
	},
	export(id, params) {
		return http.get('/');
	},
	invitationCard(invitationCardActivityId) {
		return http.get(`/invitationCard/${invitationCardActivityId}`);
	},
	updateShowStatus(id, status) {
		return http.put(`/${id}/updateShowStatus/${status}`);
	},
};
